import * as React from "react";
import { forwardRef } from "react";
const SvgYoutube = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 69, viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.615 3.184c-3.604-.246-11.631-.245-15.23 0C.488 3.45.029 5.804 0 12c.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0C23.512 20.55 23.971 18.196 24 12c-.029-6.185-.484-8.549-4.385-8.816M9 16V8l8 3.993z" }));
const ForwardRef = forwardRef(SvgYoutube);
export default ForwardRef;
